import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/skills.css";
import skillsDomains from "../assets/data/skills-domains.json";
import skillsLists from "../assets/data/skills-list.json";

const Skills = () => {
    const { t } = useTranslation();
    const skillsRef = useRef(null);

    useEffect(() => {
        if (!skillsRef.current) {
            return;
        }

        const element = skillsRef.current;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        element.classList.add("visible");
                    } else {
                        element.classList.remove("visible");
                    }
                });
            },
            {
                threshold: 0.1,
            },
        );

        observer.observe(element);

        return () => {
            observer.unobserve(element);
            observer.disconnect();
        };
    }, []);

    return (
        <>
            <div className="skills" id="skills" ref={skillsRef}>
                <div className="head">
                    <h1>{t("skills.title")}</h1>
                    <h4>{t("skills.subtitle")}</h4>
                    <hr></hr>
                </div>
                <div className="skills-cat">
                    <div className="list">
                        <h4>{t(skillsDomains.titleKey)}</h4>
                        <ul>
                            {skillsDomains.items.map((domain, index) => (
                                <li key={index}>
                                    <h5>
                                        <i className="fa-solid fa-circle-check"></i>{" "}
                                        {t(domain.titleKey)}
                                    </h5>
                                    <p>{t(domain.descriptionKey)}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="skills-list">
                    {Object.keys(skillsLists).map((key) => (
                        <div className={key} key={key}>
                            <h4>{t(skillsLists[key].titleKey)}</h4>
                            <ul>
                                {t(skillsLists[key].itemsKey, {
                                    returnObjects: true,
                                }).map((skill, index) => (
                                    <li key={index}>
                                        <i className="fa-solid fa-circle"></i>{" "}
                                        <span>{skill}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Skills;
